import React, { useEffect, useState } from "react"
import moment from "moment"
import ReactTable from "react-table"
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Label,
  Button,
  CardBody,
  FormGroup,
  InputGroup,
  InputGroupText,
  InputGroupAddon
} from "reactstrap"
import { Link } from "react-router-dom"
import { flowRight as compose } from "lodash"
import { useQuery } from "@apollo/react-hooks"
import withModal from "components/modal"
import { Spinner } from "components/spinner"
import QueryPanel, { useQueryVariables } from "components/query-panel"
import { CustomServerSideReactTableNew } from "components/utility"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { orderStatusTypes, findTypeValueByKey } from "utils/types"
import { GET_ORDERS, GET_TABLE_FIELDS, SUM_ORDERS } from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const OrderList = (props) => {
  useBread({ to: props.match.url, name: "訂單查詢" }, true)

  const columnDefs = [
    { title: "巨研訂單編號", name: "orderNumber", type: "input" },
    {
      title: "訂單狀態",
      name: "status",
      type: "select",
      options: orderStatusTypes
    },
    { title: "訂單總金額", name: "totalAmount", type: "input-number" },
    { title: "公司名稱", name: "companyName", type: "input" },
    { title: "建立者名稱", name: "userName", type: "input" },
    {
      title: "最後更新時間",
      name: "updatedAt",
      type: "date"
    }
  ]

  const fieldsDefinition = (props) => {
    return [
      {
        Header: "id",
        accessor: "id",
        show: false
      },
      {
        id: "orderNumber",
        Header: "巨研訂單編號",
        style: columStyle,
        accessor: (data) => data.orderNumber,
        Cell: (cell) => {
          return (
            <Link to={`${props.match.url}/detail/${cell.row.id}`}>
              {cell.row.orderNumber || "未成立之訂單"}
            </Link>
          )
        }
      },
      {
        id: "orderStatus",
        Header: "訂單狀態",
        style: columStyle,
        accessor: (data) => findTypeValueByKey(orderStatusTypes, data.status),
        Cell: (cell) => {
          return <div>{cell.row.orderStatus}</div>
        }
      },
      {
        id: "totalAmount",
        Header: "訂單總金額",
        style: columStyle,
        accessor: (data) => data.totalAmount,
        Cell: (cell) => {
          return (
            <div>
              {cell.row.totalAmount
                ? `NT$ ${cell.row.totalAmount.toLocaleString()}`
                : "待議價"}
            </div>
          )
        }
      },
      {
        id: "companyName",
        Header: "公司名稱",
        style: columStyle,
        accessor: (data) => data.company?.name,
        Cell: (cell) => {
          return <div>{cell.row.companyName}</div>
        }
      },
      {
        id: "user",
        Header: "建立者",
        style: columStyle,
        accessor: (data) => data.user?.name,
        Cell: (cell) => {
          return <div>{cell.row.user}</div>
        }
      },
      {
        id: "updatedAt",
        Header: "最後更新時間",
        style: columStyle,
        accessor: (data) => {
          return moment(data.updatedAt).format("YYYY-MM-DD")
        },
        Cell: (cell) => {
          return <div>{cell.row.updatedAt}</div>
        }
      }
    ]
  }

  return (
    <CustomServerSideReactTableNew
      columnDefs={columnDefs}
      queryObjectGql={GET_ORDERS}
      sumTotalQueryObjectGql={SUM_ORDERS}
      fieldsDefGql={GET_TABLE_FIELDS}
      objectRoute={props.match.url}
      hasSettingButton={false}
      fieldsDef={fieldsDefinition(props)}
    />
  )
}
const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default compose(withBreadcrumb, withModal)(OrderList)
